import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState, CrudlStatus } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class AnalyticsDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(CrudlStatus.VIEW, bean);
          }
        }}
      >
        <div className="ui-g-12">
          <h2>Station Summary: </h2>
          <label />

          <div className="ui-g-2 row"></div>
          <div className="ui-g-8 row">
            <div className="ui-g-4 cell">
              <b style={{ float: "right" }}>Name: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Description: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Operation Status: </b>
            </div>

            <div className="ui-g-4 cell">
              <label>{bean.name || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.description || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.operationStatus || "Not Set"}</label>
            </div>
            <div className="ui-g-4 cell">
              <b style={{ float: "right" }}>Site: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Building: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Location: </b>
            </div>

            <div className="ui-g-4 cell">
              <label>
                {format.getEmbeddedProperty(bean.siteBean, "siteName") ||
                  "Not Set"}
              </label>
              <br></br>
              <br></br>
              <label>
                {format.getEmbeddedProperty(bean.buildingBean, "name") ||
                  "Not Set"}
              </label>
              <br></br>
              <br></br>
              <label>
                {format.getEmbeddedProperty(bean.locationBean, "name") ||
                  "Not Set"}
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Analytics/UI/AnalyticsDisplay.js